module.exports = __webpack_public_path__ + "img/logo-blanco.fa781ab3.png";